import { Box, useColorModeValue } from '@chakra-ui/react';
import { useAppSelector } from '../../../core/hooks/storeHooks';
import { HorizontalSectionInfo } from '../../../core/types/ui/placement';
import { selectSheet } from '../../selectors/sheetSelector';
import { TopSheetSection } from '../../types';
import FormulaBar from './formulaBar/FormulaBar';

interface TopSectionProps {
  sheetId: string;
}
const TopSection: React.FC<TopSectionProps> = ({ sheetId }) => {
  // const background = useColorModeValue('#f5f8fa', '#161718');
  const section: HorizontalSectionInfo = useAppSelector((state) => {
    const sheet = selectSheet(state, sheetId);
    if (sheet) {
      return {
        isVisible: sheet.topSection.formulaBar.isVisible,
        height: sheet.topSection.formulaBar.height,
      };
    }

    return { isVisible: false, height: 0 };
  });
  return (
    <>
      <FormulaBar
        isVisible={section.isVisible}
        height={section.height} //section?.formulaBar?.height
      />
      {/* <Box
        top={`${section.height}px`}
        height="28px"
        backgroundColor={background}
        position={'absolute'}
        width={'100%'}
      /> */}
      {/* <Box
        top={`${section.height}px`}
        height="100%"
        left="0px"
        backgroundColor={background}
        position={'absolute'}
        width={'28px'}
      /> */}
    </>
  );
};

export default TopSection;
